var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-bar-icon"},[_c('nuxt-link',{attrs:{"to":"/"}},[_c('v-avatar',{attrs:{"color":"grey lighten-5","size":"56"}},[_c('v-img',{attrs:{"contain":"","src":'customers/' + _vm.customer + '/logo-dashboard.png'}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }